import { code, codes } from 'currency-codes';

export const FINANCE_TYPES = {
  directDebits: {
    id: 'directDebits',
    docDescription: 'SEPA_DIRECT_DEBITS',
  },
  receivedPayments: {
    id: 'receivedPayments',
    docDescription: 'RECEIVED_PAYMENTS',
  },
  standingOrders: {
    id: 'standingOrders',
    docDescription: 'STANDING_ORDERS',
  },
};

export const TERMINUEBERWEISUNG = 'none';

export const FINANCE_INTERVAL_TYPES = [
  'weekly',
  'monthly',
  'bi_monthly',
  'quarterly',
  'triannual',
  'half_yearly',
  'yearly',
  TERMINUEBERWEISUNG,
];

export const EXECUTION_DAY = Array.from({ length: 31 }, (_, i) => ({
  label: i + 1,
  value: i + 1,
}));

export const FINANCE_CURRENCY_CODES = codes().map((i: string) => {
  const value = i;
  const label = (code(i) as any).currency;
  return {
    label,
    value,
  };
});

export const STANDING_ORDER_FIELDS = [
  'id',
  'name',
  'iban',
  'bic',
  'amount',
  'currency',
  'interval',
  'executionDay',
  'firstExecution',
  'nextExecution',
  'lastExecution',
  'purpose',
  'comment',
];
